import { z } from 'zod/v3';

// ============================================================================
// Enum 스키마
// ============================================================================

/** 이벤트 유저 타입 */
export const membershipEventUserTypeSchema = z.enum([
  'STANDARD',
  'NEW_STANDARD',
  'RETURNING_STANDARD',
]);
export type MembershipEventUserType = z.infer<
  typeof membershipEventUserTypeSchema
>;

/** 이벤트 할인 형태(정액, 정률) */
export const membershipEventDiscountModeSchema = z.enum(['FIXED', 'PERCENT']);
export type MembershipEventDiscountMode = z.infer<
  typeof membershipEventDiscountModeSchema
>;

// ============================================================================
// Model 스키마
// ============================================================================

// lenient placeholder: 아직 사용하지 않는 중첩 서브타입(DiscountPolicyDto).
// 컴포넌트에서 읽기 시작하면 정식 스키마로 승격한다. (rule 07 참고)
const looseObjectSchema = z.object({}).passthrough();

/** 플러스 멤버십 이벤트 정보 (MembershipEventDto) */
export const membershipEventSchema = z
  .object({
    /** 이벤트 할인 금액 */
    amount: z.number().optional(),
    /** 이벤트 현재 사용한 할인 금액 */
    currentUseDiscountAmount: z.number(),
    /** 이벤트 할인 형태(정액, 정률) */
    discountMode: membershipEventDiscountModeSchema,
    /** 이벤트 할인 정책 (미사용: lenient) */
    discountPolicy: looseObjectSchema,
    /** 이벤트 종료 일시 */
    endAt: z.string(),
    /** 이벤트 최대 할인 금액 */
    maximumDiscountAmount: z.number(),
    /** 이벤트 할인 퍼센티지 */
    percentage: z.number().optional(),
    /** 이벤트 남은 할인 금액 */
    remainDiscountAmount: z.number(),
    /** 이벤트 시작 일시 */
    startAt: z.string(),
    /** 이벤트 유저 타입 */
    userType: membershipEventUserTypeSchema,
  })
  .passthrough();
export type MembershipEvent = z.infer<typeof membershipEventSchema>;

/** 플러스 멤버십 이벤트 응답 (MembershipEventResponse) */
export const membershipEventResponseSchema = z
  .object({
    /** 이벤트 정보 (이벤트 기간이 아니거나 대상이 아니면 없음) */
    event: membershipEventSchema.optional(),
  })
  .passthrough();
export type MembershipEventResponse = z.infer<
  typeof membershipEventResponseSchema
>;
